import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FindUserModel } from '../models/user';
import { Observable, Subject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class IdentityUsersService {
  emptyContactlistSubject = new Subject();
  emptyContactList : FindUserModel[] = [];

  constructor(private http: HttpClient) { }

  async getUsers(organisation: string) {
    return this.http.get(environment.identityUrl + "/api/organisations/" + organisation + "/Users");
  }
  
  async downloadUsersOverview(organisation: string) {
    return this.http.get(environment.identityUrl + "/api/organisations/" + organisation + "/Users/DownloadOverview", { observe:'response', responseType: 'blob'});
  }

  findUsersSafeSearchValue(organisation: string, givenSearchValue: string){
    if(givenSearchValue != null && givenSearchValue !== "" && givenSearchValue.length >= 3) {
      return this.http.get<FindUserModel[]>(environment.identityUrl + "/api/organisations/" + organisation + "/users/findUsersSafe" , {params:{
        searchValue: givenSearchValue
      }} )
      .pipe(
        tap<FindUserModel[]>((response:FindUserModel[])=>{
          let r:FindUserModel[];
          r = response
            .map(user=>new FindUserModel(user.voornaam,user.tussenvoegsels,user.achternaam,user.email,user.telefoon, user.id))
          return r;
        })
      );
    } else {
      this.emptyContactlistSubject.next(this.emptyContactList);
      return <Observable<FindUserModel[]>>this.emptyContactlistSubject.asObservable();
    }
  }
}
